import { ParticipantStepState, } from '@wix/ambassador-challenges-v1-participant/types';
export function isParticipateStepQuizFailed(step) {
    var _a;
    return (step.transitions[0].state === ParticipantStepState.RUNNING &&
        ((_a = step.quizSubmission) === null || _a === void 0 ? void 0 : _a.quizSubmissionId));
}
export const patchParticipantStep = (step) => {
    if (isParticipateStepQuizFailed(step)) {
        return Object.assign(Object.assign({}, step), { transitions: [
                {
                    state: ParticipantStepState.FAILED,
                    occurredAt: step.transitions[0].occurredAt,
                },
                ...step.transitions,
            ] });
    }
    return step;
};
export function patchParticipantStepList(steps) {
    return steps.map(patchParticipantStep);
}
export function patchParticipantSectionList(_sections) {
    return _sections.map((section) => (Object.assign(Object.assign({}, section), { steps: patchParticipantStepList(section.steps) })));
}
//# sourceMappingURL=patchServerEntities.js.map